import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * Auth Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Define the step of the Auth
     */
    @Prop() step!: string;

    /**
     * Image of the Auth Page
     * Used Types: Modern
     */
    @Prop() img!: string;

    /**
     * Logo image
     * Used Types: Modern
     */
    @Prop() logo!: string;

    /**
     * Alt of the logo in the Auth Page
     * Used Types: Modern
     */
    @Prop() logoAlt!: string;

    /**
     * Title of the Auth Page
     * Used Types: Modern
     */
    @Prop() authTitle!: string;

    /**
     * Description of the Auth Page
     * Used Types: Modern
     */
    @Prop() authDesc!: string;

    /**
     * Telephone to appear on the Auth page
     * Used Types: Modern
     */
    @Prop() contactTel!: string;

    /**
     * Form Footer
     * Accepts html string
     * Used Types: Modern
     */
    @Prop() formFooter!: string;

    /**
     * Show Quarkino Branding at the Form Footer
     * Accepts html string
     * Used Types: Modern
     */
    @Prop({ type: Boolean }) quarkinoBranding!: boolean;

    /**
     * Color of the link, button and forms
     */
    @Prop({ default: 'primary' }) color!: string;
}
